import { UIHeading2, UIHeading4, UIText1, UIText3 } from '@cian/ui-kit';
import { ArrowL16 } from '@cian/ui-kit/prev';
import * as React from 'react';

import * as styles from './styles.css';

type TUserCardMobileLayout = {
  companionName?: string | null;
  companionTypeName: string;
  companionIdStr?: string;
  handleClickBack: () => void;
  avatar: React.ReactNode;
  actions: React.ReactNode | null;
  offer: React.ReactNode | null;
  images: React.ReactNode | null;
  updateChatFiles: () => void;
};

export const UserCardMobileLayout: React.VFC<TUserCardMobileLayout> = ({
  companionName,
  companionTypeName,
  companionIdStr,
  handleClickBack,
  avatar,
  actions,
  offer,
  images,
  updateChatFiles,
}) => {
  const scrollContainer = React.useRef<HTMLImageElement>(null);
  const [isVisibleFixedHeader, setVisibilityFixedHeader] = React.useState<boolean>(false);

  const handleScroll = React.useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      const { scrollTop, scrollHeight, offsetHeight } = e.currentTarget;

      setVisibilityFixedHeader(scrollTop > 160);

      if (scrollHeight === scrollTop + offsetHeight) {
        updateChatFiles();
      }
    },
    [updateChatFiles],
  );

  return (
    <div className={styles['container']} data-testid="UserCardMobileLayout">
      <div className={styles['header']}>
        <button className={styles['back_button']} onClick={handleClickBack} data-testid="back_button">
          <ArrowL16 color="primary_100" />
        </button>
        {isVisibleFixedHeader && (
          <div className={styles['title__fixed']}>
            <div className={styles['name__small']}>
              <UIHeading4 color="black_100">{companionName || companionIdStr}</UIHeading4>
            </div>
            <div className={styles['type_name__small']}>
              <UIText3 color="gray60_100">{companionTypeName}</UIText3>
            </div>
          </div>
        )}
      </div>
      <div className={styles['scroll']} onScroll={handleScroll} ref={scrollContainer}>
        {avatar}
        <div className={styles['title']}>
          <div className={styles['name']}>
            <UIHeading2 color="black_100">{companionName || companionIdStr}</UIHeading2>
          </div>
          <div className={styles['type_name']}>
            <UIText1 color="gray60_100">{companionTypeName}</UIText1>
          </div>
        </div>
        {actions}
        {offer}
        {images}
      </div>
    </div>
  );
};
